// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getPriceList } from "@stoneage/App/Services/PriceList/PriceListService";
import { getDataLayer, trackAsImpersonation } from "@stoneage/App/Utilities/DataLayer";

type HandlerType = Handler<{ buttonLabel?: string }, { exportUrl?: string }>;

export const GenerateExportUrl: HandlerType = props => {
    props.exportUrl = getPriceList();
};

export const TrackGaExportPriceList: HandlerType = props => {
    const state = props.getState();
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const billToState = getBillToState(state, state.context.session?.billToId);
    const customerNumber = billToState?.value?.customerNumber;

    const googleAnalyticsData = {
        event: "myacct_downloadpricelist",
        text: props.parameter.buttonLabel || "",
        destination: props.exportUrl,
        affiliation: customerNumber || "",
        impersonation: trackAsImpersonation(state),
    };

    dataLayer.push(googleAnalyticsData);
};

export const DownloadPriceList: HandlerType = props => {
    window.open(props.exportUrl, "_self");
};

export const chain = [GenerateExportUrl, TrackGaExportPriceList, DownloadPriceList];

const exportPriceList = createHandlerChainRunner(chain, "ExportPriceList");

export default exportPriceList;
